<template>
  <div>
    <div class="pr-heading">
      <h2 v-if="!editPage">Create Press Release</h2>
      <h2 v-else>{{ selectLanguage ? 'Translation' : 'Edit Press Release' }}</h2>
      <button @click="translateLanguage" v-if="editPage && !selectLanguage">Translation</button>
      <button @click="selectLanguage = false" v-if="editPage && selectLanguage">Back</button>
    </div>
    <div class="pr-form-container" v-if="!selectLanguage">
      <form>
        <div class="form-input-div">
          <p class="form-label">Title*<span>(maximum 72 characters)</span></p>
          <input type="text" placeholder="Title" class="form-input" v-model="pressRelease.title">
          <span class="error-msg" v-if="showInputError && pressRelease.title === ''">Fill the title field</span>
          <span class="error-msg" v-if="isValidTitle && !titleLengthError">Invalid text</span>
          <span class="error-msg" v-if="titleLengthError && pressRelease.title !== ''">Please enter below 72 characters</span>
        </div>
        <div class="form-input-div">
          <p class="form-label">Short Description*</p>
          <textarea placeholder="Short description" class="form-input-textarea" v-model="pressRelease.shortDesc" />
          <span class="error-msg" v-if="showInputError && pressRelease.shortDesc === ''">Fill the Short description field</span>
          <span class="error-msg" v-if="descriptionLengthError && pressRelease.shortDesc !== ''">Please enter below 195 characters</span>
        </div>
        <div class="form-input-div">
          <p class="form-label">Lang</p>
          <select v-model="pressRelease.language" :disabled="editPage">
            <option v-for="(data,index) in language" :key="index" :value="data">{{ data }}</option>
          </select>
        </div>
        <div class="form-input-div">
          <p class="form-label">Topics*</p>
          <select v-model="pressRelease.topics" :disabled="editPage">
            <option v-for="(value, propertyName, index) in newsTopics" :key="index" :value="value">{{ propertyName }}</option>
          </select>
          <p class="error-msg" v-if="showInputError && pressRelease.topics === ''">Please select Topics</p>
        </div>
        <div class="form-input-div">
          <p class="form-label">Tags</p>
          <div class="checkbox-div" v-for="(value, propertyName, index) in dataJson.FacetsTags" :key="index">
            <input class="styled-checkbox" :id="index" type="checkbox" :value="value" v-model="pressRelease.selectedTags">
            <label :for="index">{{ propertyName }}</label>
          </div>
          <p class="error-msg" v-if="showInputError && pressRelease.selectedTags.length === 0">Please select minimum one Tag</p>
        </div>
        <div class="form-input-div">
          <p class="form-label">PDF Press Release</p>
          <div class="uploaded-file" v-if="pressRelease.pdfPrbase != ''">
            <div class="card-image">
              <img src="/-/media/Feature/NewBOPRNews/pdf.png" alt="PDF file" >
            </div>
            <div class="image-alt">
              <label>{{ pressRelease.pdfPrFileName }}</label>
            </div>
            <div class="file-action-delete">
              <button class="remove-file" type="button" @click="removeImage('pdf')">Delete</button>
            </div>
            <div class="file-action-change">
              <button class="select-file" type="button" @click="uploadImage('pdf','update')" v-if="editPage">Change</button>
            </div>
            <input type="file" class="file-input" ref="pdfPrUpdate" @change="heroFileUpload($event,'update')" accept=".pdf" >
          </div>
          <div v-else>
            <label>Add File</label>
            <button class="select-file" type="button" @click="uploadImage('pdf','create')">Select a file</button>
            <input type="file" class="file-input" ref="pdfPr" @change="heroFileUpload($event,'create')" accept=".pdf" >
            <p class="file-text">One file only, Allowed type:pdf</p>
          </div>
          <div>
            <p class="error-msg" v-if="pdfFileSizeError">Please select the file below 500 KB</p>
            <p class="error-msg" v-if="pdfFileTypeError && !pdfFileSizeError">Invalid File</p>
          </div>
        </div>
        <div class="form-input-div">
          <p class="form-label">Image</p>
          <div class="uploaded-file" v-if="pressRelease.prImagebase != ''">
            <div class="card-image">
              <img :src="prImageSrc" alt="image" >
            </div>
            <div class="image-alt">
              <label>{{ pressRelease.prImageFileName }}</label>
              <input v-model="pressRelease.prImageAlt" placeholder="Alt">
              <small>Please set an Alt for your image</small>
            </div>
            <div class="file-action-delete">
              <button class="remove-file" type="button" @click="removeImage('pr')">Delete</button>
            </div>
            <div class="file-action-change">
              <button class="select-file" type="button" @click="uploadImage('pr','update')" v-if="editPage">Change</button>
            </div>
            <input type="file" class="file-input" ref="prImageUpdate" @change="prFileUpload($event,'update')" accept="image/*" >
          </div>
          <div v-else>
            <label>Add File</label>
            <button class="select-file" type="button" @click="uploadImage('pr','create')">Select a file</button>
            <input type="file" class="file-input" ref="prImage" @change="prFileUpload($event,'create')" accept="image/*" >
            <p class="file-text">One file only, Allowed type:jpg, png</p>
          </div>
          <div>
            <p class="error-msg" v-if="prFileSizeError">Please select the file below 500 KB</p>
            <p class="error-msg" v-if="prImageFileTypeError && !prFileSizeError">Invalid File</p>
          </div>
        </div>
        <div class="form-input-div">
          <p class="form-label">Card Image* <small>(216 &times; 400)</small></p>
          <div class="uploaded-file" v-if="pressRelease.cardImagebase != ''">
            <div class="card-image">
              <img :src="cardImageSrc" alt="Card Image" >
            </div>
            <div class="image-alt">
              <label>{{ pressRelease.cardImageFileName }}</label>
              <input v-model="pressRelease.cardImageAlt" placeholder="Alt">
              <small>Please set an Alt for your image</small>
            </div>
            <div class="file-action-delete">
              <button class="remove-file" type="button" @click="removeImage('card')">Delete</button>
            </div>
            <div class="file-action-change" v-if="editPage">
              <button class="select-file" type="button" @click="uploadImage('card','update')">Change</button>
              <p>( If you change this field it will impact other version of item )</p>
            </div>
            <input type="file" class="file-input" ref="cardImageUpdate" @change="cardFileUpload($event,'update')" accept="image/*" >
          </div>
          <div v-else>
            <label>Add File</label>
            <button class="select-file" type="button" @click="uploadImage('card','create')">Select a file</button>
            <input type="file" class="file-input" ref="cardImage" @change="cardFileUpload($event,'create')" accept="image/*" >
            <p class="file-text">One file only, Allowed type:jpg, png</p>
          </div>
          <div>
            <p class="error-msg" v-if="showInputError && pressRelease.cardImageFileName === '' && !cardFileSizeError">Please add card image</p>
            <p class="error-msg" v-if="cardFileSizeError">Please select the file below 500 KB</p>
            <p class="error-msg" v-if="cardFileTypeError && !cardFileSizeError">Invalid File</p>
          </div>
        </div>
        <div class="form-input-div">
          <p class="form-label">Body*</p>
          <vue-editor v-model="pressRelease.content" v-if="bodyFormat === 'design'"/>
          <textarea class="body-text" v-model="pressRelease.content" v-else />
          <div class="body-selection">
            <label>Text format</label>
            <select v-model="bodyFormat">
              <option value="design">Design</option>
              <option value="basichtml">Basic HTML</option>
            </select>
          </div>
          <span class="error-msg" v-if="showInputError && pressRelease.content === ''">Please enter body</span>
        </div>
        <div class="form-input-div" v-if="editPage">
          <p class="form-label">Assets</p>
          <div v-if="pressRelease.pressAssets.length > 0">
            <div v-for="(data,index) in pressRelease.pressAssets" :key="index">
              <div class="uploaded-file" v-if="!data.isDeleted">
                <div class="card-image" v-if="data.fileType === 'jpg' || data.fileType === 'jpeg' || data.fileType === 'png' || data.fileType === 'svg'">
                  <img :src="data.fileUrl" alt="assest image" >
                </div>
                <div class="card-image" v-else-if="data.fileType === 'pdf'">
                  <img src="/-/media/Feature/NewBOPRNews/pdf-image.png" alt="pdf file" >
                </div>
                <div class="card-image" v-else-if="data.fileType === 'xlsx' || data.fileType === 'csv' || data.fileType === 'xls'">
                  <img src="/-/media/Feature/NewBOPRNews/xls.png" alt="Excel file" >
                </div>
                <div class="card-image" v-else-if="data.fileType === 'doc' || data.fileType === 'docx'">
                  <img src="/-/media/Feature/NewBOPRNews/doc-image.png" alt="doc file" >
                </div>
                <div class="card-image" v-else>
                  <img src="/-/media/Feature/NewBOPRNews/pdf.png" alt="other file" >
                </div>
                <div class="image-alt" v-if="data.fileType === 'jpg' || data.fileType === 'jpeg' || data.fileType === 'png' || data.fileType === 'svg'">
                  <label>{{ data.fileName }}</label>
                  <input v-model="data.fileAltName" placeholder="Alt" >
                  <small>Please set an Alt for your image</small>
                </div>
                <div class="image-alt" v-else>
                  <label>{{ data.fileName }}</label>
                </div>
                <button class="remove-file" type="button" @click="removeAssets(index)">Delete</button>
              </div>
            </div>
          </div>
          <div v-if="totalPressAssets <= 4">
            <label>Add File</label>
            <button class="select-file" type="button" @click="uploadImage('asset','create')">Select a file</button>
            <input type="file" class="file-input" ref="assets" @change="uploadAsset($event,'create')" accept=".xlsx,.xls,image/*,.doc, .docx,.ppt, .pptx,.pdf">
            <p class="file-text">Multiple file, Allowed type:jpg,png,xlsx,txt,doc,pdf,ppt</p>
          </div>
        </div>
        <div class="form-input-div">
          <p class="form-label">SEO*</p>
          <input type="text" placeholder="Title" class="form-input" v-model="pressRelease.seoTitle">
          <span class="error-msg" v-if="showInputError && pressRelease.seoTitle === ''">Fill the SEO Title field</span>
          <span class="error-msg" v-if="isValidSeoTitle && pressRelease.seoTitle !== ''">Invalid text</span>
          <input type="text" placeholder="Description" class="form-input seo-desc" v-model="pressRelease.seoDesc">
        </div>
        <div class="submit-btn-div">
          <button class="btn-save" @click="savePressRelease('save')" type="button">Save </button>
          <a :href="previewUrl" target="_blank" class="btn-save" :class="{'disabled':!editPage}">Preview</a>
          <button type="button" class="btn-save" @click="savePressRelease('publish')">Save &amp; Publish</button>
        </div>
      </form>
    </div>
    <div class="pr-form-container translation-page" v-else>
      <div class="content-table-container">
        <table aria-describedby="language list">
          <thead>
            <th id="press-language">
              Language
            </th>
            <th id="press-title">
              Title
            </th>
            <th id="press-action-column" />
          </thead>
          <tbody v-if="translationResult.ResultData !== null">
            <tr v-for="(data,index) in translationResult.ResultData" :key="index">
              <td>
                {{ data.Language }}
              </td>
              <td>{{ data.ItemName }}</td>
              <td>
                <button class="action--btn edit-btn" @click="editLanguage(data)">Edit</button>
              </td>
            </tr>
            <tr v-if="translationResult !== '' && translationResult.ResultData !== null">
              <td>
                <select v-model="selectedTranslationLang">
                  <option value="">Please select Language</option>
                  <option v-for="(data,index) in translationResult.Languages" :key="index" :value="data">{{ data }}</option>
                </select>
              </td>
              <td>{{ translationResult.ResultData[0].ItemName }}</td>
              <td>
                <button class="action--btn delete-btn" @click="createLanguage" :disabled="selectedTranslationLang === ''">Create</button>
              </td>
            </tr>
          </tbody>
          <tbody v-else>
            <tr>
              <td colspan="8" style="text-align:center">No Result found</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div class="alert-modal-container" v-if="showSuccessModal">
      <div class="main-content">
        <div class="alert-message">
          <p>{{ successMessage }}</p>
        </div>
        <div class="alert-modal-btn">
          <button class="btn-ok" @click="openContentPage">Ok</button>
          <a :href="previewUrl" target="_blank" class="btn-ok" v-if="previewUrl !== null">Preview</a>
        </div>
      </div>
    </div>
    <api-loader :is-loading="isLoading" />
    <alert-modal v-if="showAlertModal" @closeModal="closeModal" :delete-message="deleteMessage"/>
    <bo-Notification ref="notification" />
  </div>
</template>
<script>
  import { VueEditor } from 'vue2-editor';
  import ApiLoader from '../ApiLoader/api-loader';
  import { fetchData } from '@Foundation/services';
  import AlertModal from '../AlertModal/alert-modal';
  import BoNotification from '../BoNotification/bo-notification';
  export default {
    components: {
      VueEditor,
      ApiLoader,
      AlertModal,
      BoNotification
    },
    props: {
      dataJson: {
        type: Object,
        default: null
      }
    },
    data() {
      return {
        isLoading: false,
        customToolbar: [[{ header: ['','1','2','3','4','5','6'] }],['bold', 'italic', 'underline','strike'],[{ align: '' },,{ align: 'center' },{ align: 'right' },{ align: 'justify' }],['blockquote','code-block'], [{ list: 'ordered' }, { list: 'bullet' },{ list: 'check' }],[{ color: [] },{ background: [] }], ['link']],
        language: [],
        newsTopics: null,
        pressRelease: {
          title: '',
          shortDesc: '',
          language: 'en',
          topics: '',
          pdfPr: '',
          cardImage: '',
          prImage: '',
          content: '',
          pressAssets: [],
          seoTitle: '',
          seoDesc: '',
          prImagebase: '',
          cardImagebase: '',
          pdfPrbase: '',
          cardImage: '',
          cardImageAlt: '',
          cardImagebase: '',
          cardImageFileName: '',
          selectedTags: []
        },
        bodyFormat: 'design',
        pdfPrSrc: '',
        cardImageSrc: '',
        prImageSrc: '',
        showInputError: false,
        isValidTitle: false,
        isValidSeoTitle: false,
        titleLengthError: false,
        descriptionLengthError: false,
        editPage: false,
        previewUrl: '',
        prFileSizeError: false,
        cardFileSizeError: false,
        pdfFileSizeError: false,
        editItemId: '',
        selectLanguage: false,
        translationResult: '',
        selectedTranslationLang: '',
        showSuccessModal: false,
        showAlertModal: false,
        isPdfDeleted: false,
        isPrImageDeleted: false,
        isCardImageDeleted: false,
        prImageUrl: '',
        pdfUrl: '',
        cardImageUrl: '',
        editItemLanguage: '',
        pdfFileTypeError: false,
        cardFileTypeError: false,
        prImageFileTypeError: false,
        deleteMessage: '',
        deleteImageType: '',
        deleteAssetIndex: ''
      };
    },
    computed: {
      totalPressAssets() {
        const assests = this.pressRelease.pressAssets.filter((data)=>{
          return !data.isDeleted;
        });
        return assests.length;
      }
    },
    mounted() {
      this.newsTopics = this.dataJson.Topics;
      this.language = this.dataJson.Languages;
      const urlParams = new URLSearchParams(window.location.search);
      const myParam = urlParams.get('ItemId');
      if (myParam !== null) {
        this.editPage = true;
        this.updateValues();
      }
    },
    methods: {
      uploadImage(type,action) {
        if (action === 'create') {
          if (type === 'pdf') {
            this.$refs.pdfPr.click();
          } else if (type === 'card') {
            this.$refs.cardImage.click();
          } else if (type === 'pr') {
            this.$refs.prImage.click();
          } else {
            this.$refs.assets.click();
          }
        } else {
          if (type === 'pdf') {
            this.$refs.pdfPrUpdate.click();
          } else if (type === 'pr') {
            this.$refs.prImageUpdate.click();
          } else {
            this.$refs.cardImageUpdate.click();
          }
        }
      },

      heroFileUpload(e, action) {
        if (this.uploadFileType(e) === 'application/pdf') {
          if (e.target.files[0].size <= 12000000) {
            this.createImage(e.target.files[0],'pdf');
            this.pressRelease.pdfPr = e.target.files[0];
            this.pressRelease.pdfPrFileName = this.sanitizeFileName(e.target.files[0].name);
            this.pressRelease.pdfPrFileFormat = this.getFileType(e.target.files[0].name);
            this.pdfFileSizeError = false;
            this.pdfFileTypeError = false;
            if (action === 'update') {
              this.isPdfDeleted = true;
              this.pdfUrl = '';
            }
          } else {
            this.pdfFileTypeError = false;
            this.pdfFileSizeError = true;
          }
        } else {
          this.pdfFileSizeError = false;
          this.pdfFileTypeError = true;
        }
      },

      cardFileUpload(e,action) {
        if (this.uploadFileType(e) === 'image/jpg' || this.uploadFileType(e) === 'image/jpeg' || this.uploadFileType(e) === 'image/png' || this.uploadFileType(e) === 'image/svg+xml') {
          if (e.target.files[0].size <= 500000) {
            this.createImage(e.target.files[0],'card');
            this.pressRelease.cardImage = e.target.files[0];
            this.pressRelease.cardImageAlt = this.sanitizeFileName(e.target.files[0].name);
            this.pressRelease.cardImageFileName = this.sanitizeFileName(e.target.files[0].name);
            this.pressRelease.cardImageFileFormat = this.getFileType(e.target.files[0].name);
            this.cardFileSizeError = false;
            this.cardFileTypeError = false;
            if (action === 'update') {
              this.isCardImageDeleted = true;
              this.cardImageUrl = '';
            }
          } else {
            this.cardFileSizeError = true;
          }
        } else {
          this.cardFileTypeError = true;
        }
      },

      prFileUpload(e,action) {
        if (this.uploadFileType(e) === 'image/jpg' || this.uploadFileType(e) === 'image/jpeg' || this.uploadFileType(e) === 'image/png' || this.uploadFileType(e) === 'image/svg+xml') {
          if (e.target.files[0].size <= 500000) {
            this.createImage(e.target.files[0],'pr');
            this.pressRelease.prImage = e.target.files[0];
            this.pressRelease.prImageAlt = this.sanitizeFileName(e.target.files[0].name);
            this.pressRelease.prImageFileName = this.sanitizeFileName(e.target.files[0].name);
            this.pressRelease.prImageFileFormat = this.getFileType(e.target.files[0].name);
            this.prFileSizeError = false;
            this.prImageFileTypeError = false;
            if (action === 'update') {
              this.isPrImageDeleted = true;
              this.prImageUrl = '';
            }
          } else {
            this.prImageFileTypeError = false;
            this.prFileSizeError = true;
          }
        } else {
          this.prFileSizeError = false;
          this.prImageFileTypeError = true;
        }
      },

      uploadFileType(e) {
        return e.target.files[0].type;
      },

      sanitizeFileName(fileName) {
        const newFileName = fileName.split('.');
        let name = '';
        newFileName.forEach((element,i) => {
          if (newFileName.length - 1 !== i) {
            name += element;
          }
        });
        return name;
      },

      getFileType(fileName) {
        const newFileName = fileName.split('.');
        return newFileName[newFileName.length - 1];
      },

      uploadAsset(e) {
        const file = e.target.files[0];
        const reader = new FileReader();
        const obj = {
          fileBase: '',
          fileType: this.getFileType(file.name),
          fileName: this.sanitizeFileName(file.name),
          fileAltName: this.sanitizeFileName(file.name),
        };
        reader.onload = (e) => {
          obj.fileBase = e.target.result;
          this.addAssets(obj);
        };
        reader.readAsDataURL(file);
      },

      addAssets(data) {
        const formData = new FormData();
        formData.append('AssetStream', data.fileBase.split('base64,')[1]);
        formData.append('AssetType', data.fileType);
        formData.append('AssetName', data.fileName);
        formData.append('AssetAltText', data.fileAltName);
        formData.append('ItemId', this.editItemId);
        formData.append('Topic', this.pressRelease.topics);
        formData.append('ItemName', this.dataJson.ItemName);
        formData.append('Language', this.editItemLanguage);
        formData.append('ArticleType', 'press');
        this.isLoading = true;
        fetch('/Content-News-PR/UploadMediaAsset', {
          method: 'POST',
          body: formData
        })
          .then(response => response.json())
          .then((response) => {
            this.isLoading = false;
            const file = {
              fileUrl: response.AssetUrl,
              fileType: data.fileType,
              fileName: response.AssetName,
              fileAltName: response.AssetAltText,
              fileId: response.AssetId,
              isNewFile: true,
              isDeleted: false
            };
            this.pressRelease.pressAssets.push(file);
            this.$refs.notification.showNotification(true,'Assets added Successfully',true);
          })
          .catch(() => {
            this.isLoading = false;
            this.$refs.notification.showNotification(true,'Failed',false);
          });
      },

      createImage(file,type) {
        const reader = new FileReader();
        if (type === 'pdf') {
          reader.onload = (e) => {
            this.pdfPrSrc = e.target.result;
            this.pressRelease.pdfPrbase = this.pdfPrSrc.split('base64,')[1];
          };
        } else if (type === 'pr') {
          reader.onload = (e) => {
            this.prImageSrc = e.target.result;
            this.pressRelease.prImagebase = this.prImageSrc.split('base64,')[1];
          };
        } else {
          reader.onload = (e) => {
            this.cardImageSrc = e.target.result;
            this.pressRelease.cardImagebase = this.cardImageSrc.split('base64,')[1];
          };
        }
        reader.readAsDataURL(file);
      },

      removeImage(type) {
        const message = 'Are you sure you want to delete this media item version from Media library';
        if (type === 'pdf') {
          if (this.editPage && !this.isPdfDeleted) {
            this.deleteImageType = type;
            this.showAlertModal = true;
            this.deleteMessage = message;
          } else {
            this.deleteImageLocal(type);
          }
        } else if (type === 'pr') {
          if (this.editPage && !this.isPrImageDeleted) {
            this.deleteImageType = type;
            this.showAlertModal = true;
            this.deleteMessage = message;
          } else {
            this.deleteImageLocal(type);
          }
        } else {
          if (this.editPage && !this.isCardImageDeleted) {
            this.deleteImageType = type;
            this.showAlertModal = true;
            this.deleteMessage = 'If you delete this from media library it will impact other version of item';
          } else {
            this.deleteImageLocal(type);
          }
        }
      },

      deleteImageLocal(type) {
        if (type === 'pdf') {
          this.pdfPrSrc = '';
          this.pressRelease.pdfPr = '';
          this.pressRelease.pdfPrbase = '';
          this.pressRelease.pdfPrFileName = '';
          this.pressRelease.pdfPrFileFormat = '';
        } else if (type === 'pr') {
          this.prImageSrc = '';
          this.pressRelease.prImagebase = '';
          this.pressRelease.prImage = '';
          this.pressRelease.prImageAlt = '';
          this.pressRelease.prImageFileName = '';
          this.pressRelease.prImageFileFormat = '';
        } else {
          this.cardImageSrc = '';
          this.pressRelease.cardImagebase = '';
          this.pressRelease.cardImage = '';
          this.pressRelease.cardImageAlt = '';
          this.pressRelease.cardImageFileName = '';
          this.pressRelease.cardImageFileFormat = '';
        }
      },

      deleteImage(type) {
        this.isLoading = true;
        const imgUrl = type === 'pdf' ? this.pdfPrSrc : type === 'pr' ? this.prImageSrc :  type === 'card' ? this.cardImageSrc : this.pressRelease.pressAssets[this.deleteAssetIndex].fileUrl;
        fetchData(`/Content-News-PR/DeleteMediaItem?mediaUrl=${imgUrl}&language=${this.dataJson.ItemLanguage}`).then((response)=>{
          if (response === true) {
            this.isLoading = false;
            if (type === 'pr') {
              this.deleteImageLocal(type);
              this.isPrImageDeleted = true;
              this.prImageUrl = '';
            } else if (type === 'pdf') {
              this.deleteImageLocal(type);
              this.isPdfDeleted = true;
              this.pdfUrl = '';
            } else if (type === 'card') {
              this.deleteImageLocal(type);
              this.isCardImageDeleted = true;
              this.cardImageUrl = '';
            } else {
              this.pressRelease.pressAssets[this.deleteAssetIndex].isDeleted = true;
            }
            this.$refs.notification.showNotification(true,'File Deleted Successfully',true);
          } else {
            this.isLoading = false;
            this.$refs.notification.showNotification(true,'Failed',false);
          }
        });
      },

      removeAssets(index) {
        this.deleteImageType = 'assets';
        this.deleteAssetIndex = index;
        this.showAlertModal = true;
        this.deleteMessage = 'Are you sure you want to delete this media item version from Media library';
      },

      savePressRelease(type) {
        if (this.pressRelease.title === '' || this.pressRelease.content === '' || this.pressRelease.topics === '' || this.pressRelease.seoTitle === '' || this.pressRelease.shortDesc === '' || this.pressRelease.cardImageFileName === '' || this.pressRelease.selectedTags.length === 0) {
          this.showInputError = true;
        } else if (this.pressRelease.title.length > 72) {
          this.titleLengthError = true;
        } else if (this.pressRelease.shortDesc.length > 195) {
          this.descriptionLengthError = true;
        } else if (this.pressRelease.title.indexOf('>') > -1 ||  this.pressRelease.title.indexOf('<') > -1 ||  this.pressRelease.title.indexOf('%') > -1) {
          this.isValidTitle = true;
        } else if (this.pressRelease.seoTitle.indexOf('>') > -1 ||  this.pressRelease.seoTitle.indexOf('<') > -1 ||  this.pressRelease.seoTitle.indexOf('%') > -1) {
          this.isValidSeoTitle = true;
        } else {
          this.showInputError = false;
          this.isValidTitle = false;
          this.isValidSeoTitle = false;
          this.titleLengthError = false;
          this.descriptionLengthError = false;
          this.isLoading = true;
          const bodyContent = String(this.pressRelease.content).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
          const shorDescription = String(this.pressRelease.shortDesc).replace(/(?:\r\n|\r|\n)/g, '<br />').replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
          const formData = new FormData();
          formData.append('Language', this.pressRelease.language);
          formData.append('Topic', this.pressRelease.topics);
          formData.append('Title', this.pressRelease.title);
          formData.append('ShortDesc',shorDescription);
          formData.append('SeoTitle', this.pressRelease.seoTitle);
          formData.append('SeoDesc', this.pressRelease.seoDesc);
          formData.append('BodyContent', bodyContent);
          let selectedTags = '';
          this.pressRelease.selectedTags.forEach((data,index)=>{
            if (this.pressRelease.selectedTags.length <= 1) {
              selectedTags = data;
            } else {
              if (this.pressRelease.selectedTags.length - 1 === index) {
                selectedTags = `${selectedTags}${data}`;
              } else {
                selectedTags = `${selectedTags}${data}|`;
              }
            }
          });
          formData.append('SelectedFacetValue', selectedTags);
          if (this.editPage && !this.isPdfDeleted) {
            formData.append('PressMainPdf', '');
            formData.append('PressMainPdfName', '');
            formData.append('PdfUrl',this.pdfUrl);
          } else {
            formData.append('PressMainPdf', this.pressRelease.pdfPrbase);
            formData.append('PressMainPdfName', this.pressRelease.pdfPrFileName);
            formData.append('PdfUrl',this.pdfUrl);
          }

          if (this.editPage && !this.isCardImageDeleted) {
            formData.append('CardImage', '');
            formData.append('CardImageAlt', '');
            formData.append('CardImageFileName', '');
            formData.append('CardImageFileFormat', '');
            formData.append('CardImageUrl', this.cardImageUrl);
          } else {
            formData.append('CardImage', this.pressRelease.cardImagebase);
            formData.append('CardImageAlt', this.pressRelease.cardImageAlt);
            formData.append('CardImageFileName', this.pressRelease.cardImageFileName);
            formData.append('CardImageFileFormat', this.pressRelease.cardImageFileFormat);
            formData.append('CardImageUrl', this.cardImageUrl);
          }

          if (this.editPage && !this.isPrImageDeleted) {
            formData.append('PressImage', '');
            formData.append('PressImageAlt', '');
            formData.append('PressImageFileFormat', '');
            formData.append('prImageUrl', this.prImageUrl);
          } else {
            formData.append('PressImage', this.pressRelease.prImagebase);
            formData.append('PressImageAlt', this.pressRelease.prImageAlt);
            formData.append('PressImageFileFormat', this.pressRelease.prImageFileFormat);
            formData.append('PressImageFileName', this.pressRelease.prImageFileName);
            formData.append('prImageUrl', this.prImageUrl);
          }
          formData.append('ArticleType','press');

          if (this.editPage) {
            let assets = '';
            this.pressRelease.pressAssets.forEach((data)=>{
              if (data.isDeleted) {
                assets += data.fileId + '|';
              } else {
                if (!data.isNewFile) {
                  assets += data.fileUrl + ';' + data.fileId + '|';
                } else {
                  assets += data.fileUrl + '|';
                }
              }
            });
            formData.append('prAssets', assets);
          }

          if (this.editPage === true) {
            formData.append('ItemId',this.editItemId);
            if (this.languageCreated === true) {
              if (type === 'publish') {
                formData.append('action', 'addlangpublish');
              } else {
                formData.append('action', 'addlangversion');
              }
            } else {
              if (type === 'publish') {
                formData.append('action', 'updateitempublish');
              } else {
                formData.append('action', 'updateitem');
              }
            }
          } else {
            if (type === 'publish') {
              formData.append('action', 'createitempublish');
            } else {
              formData.append('action', 'createitem');
            }
          }
          fetch('/Content-News-PR/ProcessCreateUpdateArticle', {
            method: 'POST',
            body: formData
          })
            .then(response => response.json())
            .then((response) => {
              if (response.IsAuthenticated) {
                this.isLoading = false;
                this.showSuccessModal = true;
                this.previewUrl = response.CreateUpdateResponse.PreviewUrl;
                this.editItemId = response.CreateUpdateResponse.ItemId;
                this.successMessage = response.ResponseMessage === null ? 'Press Release Created Successfully' : response.ResponseMessage;
              } else {
                window.location.href = '/content-news-pr/newbologin/';
              }
            })
            .catch((response) => {
              this.isLoading = false;
              this.$refs.notification.showNotification(true,response.ResponseMessage === null ? 'Failed' : response.ResponseMessage,false);
            });
        }
      },
      translateLanguage() {
        this.isLoading = true;
        fetchData(`/Content-News-PR/LoadTransaltionOptions?itemId=${this.editItemId}&Language=${this.editItemLanguage}`).then((response)=>{
          if (response.IsAuthenticated) {
            this.translationResult = response;
            this.selectLanguage = true;
            this.isLoading = false;
            this.selectedTranslationLang = '';
          } else {
            this.isLoading = false;
            window.location.href = '/content-news-pr/newbologin/';
          }
        });
      },
      createLanguage() {
        this.selectLanguage = false,
        this.pressRelease.language = this.selectedTranslationLang;
        this.languageCreated = true;
      },
      editLanguage(data) {
        this.selectLanguage = !this.selectLanguage;
        this.languageCreated = false;
        this.pressRelease.language = data.Language;
        const urlQuery = new URLSearchParams(window.location.search);
        const lang = urlQuery.get('Language');
        if (data.Language !== lang) {
          window.location.href = `/Content-News-PR/Create-Press-Release/?ItemId=${this.editItemId}&Language=${data.Language}`;
        }
      },
      updateValues() {
        this.editItemId = this.dataJson.ItemId;
        this.editItemLanguage = this.dataJson.ItemLanguage;
        this.pressRelease.title = this.dataJson.Title;
        this.pressRelease.language = this.dataJson.ItemLanguage;
        this.pressRelease.topics = this.dataJson.ItemTopic;
        this.pressRelease.seoTitle = this.dataJson.SeoTitle;
        this.pressRelease.seoDesc = this.dataJson.SeoDesc;
        this.pressRelease.content = this.dataJson.Body;
        this.previewUrl = this.dataJson.CreateUpdateResponse.PreviewUrl;
        this.prImageSrc = this.dataJson.PressImageUrl;
        this.pdfPrSrc = this.dataJson.PdfUrl;
        this.cardImageSrc = this.dataJson.CardImgUrl;
        this.prImageUrl = this.dataJson.PressImageUrl;
        this.pdfUrl = this.dataJson.PdfUrl;
        this.cardImageUrl = this.dataJson.CardImgUrl;
        if (this.dataJson.ShortDesc !== null && this.dataJson.ShortDesc !== '') {
          this.pressRelease.shortDesc = this.dataJson.ShortDesc.replace(/<br\s*\/?>/g,'\n');
        }
        if (this.dataJson.PdfUrl !== null && this.dataJson.PdfUrl !== '') {
          let pdfName = this.dataJson.PdfUrl.split('/');
          pdfName = pdfName[pdfName.length - 1];
          this.pressRelease.pdfPrbase = this.dataJson.PdfUrl;
          this.pressRelease.pdfPrFileName = pdfName;
          this.pressRelease.pdfPrFileFormat = pdfName.split('.')[1];
        } else {
          this.isPdfDeleted = true;
        }
        if (this.dataJson.PressImageUrl !== null && this.dataJson.PressImageUrl !== '') {
          let pdfImageName = this.dataJson.PressImageUrl.split('/');
          pdfImageName = pdfImageName[pdfImageName.length - 1];
          this.pressRelease.prImagebase = this.dataJson.PressImageUrl;
          this.pressRelease.prImageFileName = pdfImageName;
          this.pressRelease.prImageFileFormat = pdfImageName.split('.')[1];
          this.pressRelease.prImageAlt = this.dataJson.PressImgAlt;
        } else {
          this.isPrImageDeleted = true;
        }
        if (this.dataJson.CardImgUrl !== null && this.dataJson.CardImgUrl !== '') {
          let cardImageName = this.dataJson.CardImgUrl.split('/');
          cardImageName = cardImageName[cardImageName.length - 1];
          this.pressRelease.cardImagebase = this.dataJson.CardImgUrl;
          this.pressRelease.cardImageFileName = cardImageName;
          this.pressRelease.cardImageFileFormat = cardImageName.split('.')[1];
          this.pressRelease.cardImageAlt = this.dataJson.CardImgAlt;
        } else {
          this.isCardImageDeleted = true;
        }
        if (this.dataJson.PressMediaAssets.length > 0) {
          this.dataJson.PressMediaAssets.forEach((data)=>{
            let fileName = data.AssetUrl.split('/');
            fileName = fileName[fileName.length - 1];
            const obj = {
              fileUrl: data.AssetUrl,
              fileType: data.AssetType,
              fileName: fileName,
              fileAltName: fileName,
              fileId: data.AssetItemId,
              isNewFile: false,
              isDeleted: false
            };
            this.pressRelease.pressAssets.push(obj);
          });
        }
        this.dataJson.SelectedFacets.split('|').forEach((data)=>{
          if (data !== '') {
            this.pressRelease.selectedTags.push(data);
          }
        });
      },
      closeModal(val) {
        if (val === 'ok') {
          this.deleteImage(this.deleteImageType);
          this.showAlertModal = false;
        } else {
          this.showAlertModal = false;
        }
      },
      openContentPage() {
        window.location.href = `/content-news-pr/create-press-release/?ItemId=${this.editItemId}&Language=${this.pressRelease.language}`;
      },
    }
  };
</script>
<style lang="scss" src="./bo-press-release.scss"></style>
